<template>
    <Loader v-if="!formDataLoaded" />

    <div v-else class="preInscription">
        <div :class="['preInscription__image', formData.targetType.toLowerCase() === 'joven' ? 'preInscription__image--joven' : '']"></div>
        <div v-if="typeof pageStage === 'number'" class="preInscription__container">
        <!-- <div v-if="pageStage === 0 || pageStage <= 1" class="preInscription__container"> -->
            <div class="preInscription__stages" v-if="!coursePreinscriptionId">
                <div :class="`preInscription__stages${pageStage > 1 ? '--done' : pageStage === 1 ? '--pending' : '--disabled' }`">
                    <i v-if="pageStage > 1" class="preInscription__stages--stageNumber material-icons-outlined">done</i>
                    <span v-else class="preInscription__stages--stageNumber">1</span>
                    Datos básicos
                </div>
                <div :class="`preInscription__stages${pageStage > 3 && pageStage !== '2b' ? '--done' : pageStage < 4 && pageStage > 1  ? '--pending' : '--disabled'}`">
                    <i v-if="pageStage > 3" class="preInscription__stages--stageNumber material-icons-outlined">done</i>
                    <span v-else class="preInscription__stages--stageNumber">2  </span>
                    Datos adicionales
                </div>

                <div :class="{'preInscription__stages--disabled': pageStage < 4}">Invitación</div>
            </div>
            <div class="preInscription__content">
                <img class="preInscription__forgeLogo" src="@\assets\logo-fundacion-forge.png" alt="" />
                <div class="preInscription__title">
                    <!-- <h2>{{ stageId === 1 ? 'PREINSCRIPCIÓN' : 'INSCRIPCIÓN' }} PROGRAMA</h2> -->
                    <template v-if="formData.courseType === 'ON_DEMAND' && formData.targetType === 'JOVEN'">
                        <h2>¿Comenzamos?</h2> 
                    </template>
                    <template v-else>
                        <h2>INSCRIPCIÓN PROGRAMA</h2>
                        <strong>{{formData.title}}</strong>
                    </template>
                    <!-- <span>PageStage: {{pageStage}}</span>
                    <span>pagesCount: {{pagesCount}}</span>
                    <span>Fields: {{fieldsCount}}</span> -->
                </div>
                <template v-if="!formData.category?.fields || formData.category.fields.length === 0">
                    <!-- <span class="preInscription__activity">Captcha</span> -->
                     <!-- form with only checkbox captcha -->
                     
                     <form class="preInscription__form" @submit.prevent="onSubmitCaptcha()">
                         <!-- <div class="preInscription__form--input__checkbox" >
                             <input type="checkbox" name="captcha" id="captcha" v-model="captcha" :true-value="true" :false-value="false">
                             <label for="captcha">No soy un robot</label>
                        </div> -->
                        <div class="g-recaptcha" data-sitekey="6LdCmqoUAAAAANbRJMfkkcXbAkb5ckFo04AYfcVL" style="display: flex;justify-content: center;padding: 20px 0px;"></div>
                        <!-- <button :disabled="onSubmitLoaded || !captcha" class="preInscription__button--forward" :style="{'width': '100%'}" >{{ $t('global.CONTINUE') }} <i class="material-icons-outlined">arrow_forward</i></button> -->
                        <button :disabled="onSubmitLoaded" class="preInscription__button--forward" :style="{'width': '100%'}" >{{ $t('global.CONTINUE') }} <i class="material-icons-outlined">arrow_forward</i></button>
                    </form>
                </template>
                <template v-else>
                    <span class="preInscription--activity" v-if="pageStage == 0">Ingresa tu email</span>
                    <!-- <span class="preInscription--activity" v-else>{{pageStage}}. Completa los siguientes datos:</span> -->
                    <span class="preInscription--activity" v-else>Completa los siguientes datos:</span>
                        <form class="preInscription__form" @submit.prevent="onSubmit()">
                            <!-- template v-for fields -->
                            <template v-for="(data, index) in formData.category.fields" v-bind:key="data.paramName">
    
                                <!-- CHECKBOX -->
                                <template v-if="data.paramType === 'checkbox' && handleWhyShowInStep(data.paramName) ">
                                    <div class="preInscription__form--input__checkbox" >
                                        <input type="checkbox" :name="data.paramName" :id="`${index}-cb`" v-model="states[data.paramName]" :true-value="true" :false-value="false">
                                        <label :for="`${index}-cb`">{{data.paramName}}</label>
                                    </div>
                                    <small class="input-message" v-if="validates[data.paramName].required.$invalid && submitted " ><i class='material-icons'>error_outline</i>{{validates[data.paramName].required.$message}}</small>
                                </template>
                                
                                <!-- SELECT -->
    
                                <template v-else-if="data.paramType === 'SELECT' && handleWhyShowInStep(data.paramName)">
                                    <Select 
                                        v-if="!data.isCustomField"
                                        mode="simple"
                                        :label="$t('preInscription.fields.' + data.paramName)"
                                        :id="data.paramName"
                                        :isError="validates[data.paramName].required.$invalid && submitted"
                                        :errorMessage="validates[data.paramName].required.$message"
                                        :values="data.values"
                                        v-model="states[data.paramName]"
                                        valueProp="id"
                                        valueLabel="name"
                                        :isDropdown="true"
                                    />
                                    <Select 
                                        v-else
                                        mode="simple"
                                        :label="$t('preInscription.fields.' + data.paramName)"
                                        :id="data.paramName"
                                        :isError="validates[data.paramName].required.$invalid && submitted"
                                        :errorMessage="validates[data.paramName].required.$message"
                                        :values="data.values"
                                        v-model="states[data.paramName]"
                                    />
                                </template>
    
    
                                <!-- EMAIL -->
    
                                <template v-else-if="data.paramName === 'EMAIL' && handleWhyShowInStep(data.paramName)">
                                    <Input 
                                        type="text" 
                                        :label="$t('preInscription.fields.' + data.paramName)" 
                                        :placeholder="$t('preInscription.fields.' + data.paramName)" 
                                        v-model="states['EMAIL']" 
                                        :id="data.paramName" tooltipTitle="EMAIL" 
                                        tooltipMessage="Este es el mail para ingresar a la plataforma  y el que utilizaremos para comunicarnos contigo en todo momento. " 
                                        :isError="(validates['EMAIL'].required.$invalid && submitted) || validates['EMAIL'].email.$invalid" 
                                        :errorMessage="validates['EMAIL'].email.$invalid ? validates['EMAIL'].email.$message : validates['EMAIL'].required.$message"
                                        :disabled="emailDisabled"
                                    />
                                </template>
    
                                <!-- MULTISELECT -->
    
                                <template v-else-if="data.paramName === 'MULTISELECT' && handleWhyShowInStep(data.paramName)">
                                    <Select 
                                        v-if="!data.isCustomField"
                                        mode="multi"
                                        :label="$t('preInscription.fields.' + data.paramName)"
                                        :id="data.paramName"
                                        :isError="validates[data.paramName].required.$invalid && submitted"
                                        :errorMessage="validates[data.paramName].required.$message"
                                        :values="data.values"
                                        v-model="states[data.paramName]"
                                        valueProp="id"
                                        valueLabel="name"
                                        :isDropdown="true"
                                    />
                                    <Select 
                                        v-else
                                        mode="multi"
                                        :label="$t('preInscription.fields.' + data.paramName)"
                                        :id="data.paramName"
                                        :isError="validates[data.paramName].required.$invalid && submitted"
                                        :errorMessage="validates[data.paramName].required.$message"
                                        :values="data.values"
                                        v-model="states[data.paramName]"
                                    />
                                </template>
    
    
    
                                <!-- TEXTAREA -->
    
                                <Input 
                                    v-else-if="data.paramType === 'LONGSTRING' && handleWhyShowInStep(data.paramName)"
                                    type="textarea"
                                    :label="$t('preInscription.fields.' + data.paramName)"
                                    v-model="states[data.paramName]"
                                />
                                
                                <!-- DATE (CON LABEL) -->
    
                                <template v-else-if="data.paramType === 'DATE' && handleWhyShowInStep(data.paramName)">
                                    <DatePicker 
                                        v-model="states[data.paramName]" 
                                        :id="data.paramName" 
                                        :label="$t('preInscription.fields.' + data.paramName)" 
                                        :isError="validates[data.paramName].required.$invalid && submitted"
                                        :errorMessage="validates[data.paramName].required.$message"
                                    />
                                </template>
    
                                <!-- NUMERO DE TELEFONO CON PREFIJO -->
    
                                <template v-else-if="data.paramName === 'PHONE' && handleWhyShowInStep(data.paramName)">
                                    <div class="preInscription__form--doubleSelect">
                                        <Select 
                                            mode="simple"
                                            :label="$t('preInscription.fields.PREFIX')"
                                            :id="data.paramName + 'phoneCode'"
                                            :values="phoneCodes"
                                            v-model="states[`${data.paramName}CODE`]"
                                            :isError="(validates[data.paramName].required.$invalid || validates[data.paramName + 'CODE'].required.$invalid) && submitted"
                                            @input="checkPhoneCharacters"
                                        />
                                        <Input 
                                            type="text"
                                            :placeholder="$t('preInscription.fields.' + data.paramName)"
                                            :label="$t('preInscription.fields.' + data.paramName)"
                                            v-model="states[data.paramName]"
                                            :id="data.paramName"
                                            :isError="(validates[data.paramName].required.$invalid || validates[data.paramName + 'CODE'].required.$invalid) && submitted || phoneMaxCharacters"
                                            :errorMessage="validates[data.paramName].required.$message || phoneMaxCharacters ? 'Máximo 40 caracteres' : ''"
                                            @input="checkPhoneCharacters"
                                        />
                                    </div>
                                </template>
    
    
    
                                <template v-else-if="data.paramName === 'SCHOOLNAME' && handleWhyShowInStep(data.paramName)">
                                    <Input 
                                        type="text" 
                                        :label="$t('preInscription.fields.' + data.paramName)" 
                                        :placeholder="$t('preInscription.fields.' + data.paramName)" 
                                        v-model="states['SCHOOLNAME']" 
                                        :id="data.paramName"
                                        :tooltipTitle="data.paramName" 
                                        tooltipMessage="Nombre de escuela / liceo en el que trabajas. Si trabajas en más de una, indica la que tienes más horas asignadas." 
                                        :isError="validates['SCHOOLNAME'].required.$invalid && submitted" 
                                        :errorMessage="validates['SCHOOLNAME'].required.$message"
                                    />
                                </template>


                                
                                <!-- NUMBER -->
                                <Input
                                    v-else-if="data.paramType === 'POSITIVENUMBER' && handleWhyShowInStep(data.paramName)"
                                    type="number"
                                    :label="$t('preInscription.fields.' + data.paramName)"
                                    v-model="states[data.paramName]"
                                    :id="data.paramName"
                                    :isError="validates[data.paramName].required.$invalid && submitted"
                                    :errorMessage="validates[data.paramName].required.$message"
                                />
    

                                <!-- RESTO DE INPUTS -->
    
                                <template v-else-if="handleWhyShowInStep(data.paramName)" >
                                    <Input 
                                        :type="data.paramType"
                                        :placeholder="$t('preInscription.fields.' + data.paramName)"
                                        :label="$t('preInscription.fields.' + data.paramName)"
                                        v-model="states[data.paramName]"
                                        :isError="validates[data.paramName].required.$invalid && submitted || data.paramName === 'DNI' && dniMaxCharacters"
                                        :errorMessage="validates[data.paramName].required.$message || dniMaxCharacters ? 'Máximo 40 caracteres' : ''"
                                        :id="data.paramName"
                                        @input="checkDniCharacters"
                                    />
                                </template>
                                
                            </template>
                            
    
    
                            <div class="preInscription__buttons">

                                <button @click="pageStage--" v-if="pageStage !== 0 && pageStage !== 2" type="button" class="preInscription__button--backward"><i class="material-icons-outlined">arrow_backward</i> Atrás</button>

                                <!-- if pagestage2 and email decrement -->
                                <button @click="pageStage--" v-if="pageStage == 2 && formData.category.fields.some(field => field.paramName === 'FIRSTNAME')" type="button" class="preInscription__button--backward"><i class="material-icons-outlined">arrow_backward</i> Atrás</button>

                                <!-- <button @click="pageStage--" v-if="pageStage == 2 && !formData.category.fields['FIRSTNAME']" type="button" class="preInscription__button--backward"><i class="material-icons-outlined">arrow_backward</i> Atrás</button> -->

                                 

                                <button @click="pageStage = 0" v-if="pageStage == 2 && !formData.category.fields.some(field => field.paramName === 'FIRSTNAME')" type="button" class="preInscription__button--backward"><i class="material-icons-outlined">arrow_backward</i> Atrás</button>

                                <button :disabled="onSubmitLoaded || !states['EMAIL'] || validates['EMAIL'].email.$invalid"
                                class="preInscription__button--forward" :style="{'width': '100%'}" >{{ $t('global.CONTINUE') }} <i class="material-icons-outlined">arrow_forward</i></button>
                                
                            </div>
                        </form>
                        <div v-if="pageStage === 1 || pageStage === 2" class="terms">Haciendo click en “Continuar” aceptas los <a :href="`/terms.pdf?v=${linkRandParam}`" target="_blank">Términos y Condiciones y las Políticas de Privacidad</a> de Forge Fondation</div>
                </template>
            </div>
        </div>


        <div v-else-if="pageStage === 'InscriptionFinished'" class="preInscription__continue">
            <img class="preInscription__forgeLogo" src="@\assets\logo-fundacion-forge.png" alt="" />
            <h3>
                <strong>Felicitaciones.</strong><br>
                La <strong>inscripción</strong> fue realizada con <strong>éxito.</strong>
            </h3>
            <img class="preInscription__continue--ilustration" src="@/assets/preInscription_ilustration.png" />
            <span class="preInscription__continue--howContinue">
                <strong>¿Cómo seguimos?</strong>
                <br>
                <br>
                Te contactaremos a tu mail con el acceso a la plataforma y toda la información del Curso.
            </span>
        </div>


        <!-- SE USA -->
        <div v-else-if="pageStage === 'NotStarted'" class="preInscription__sendEmail">
            <div class="preInscription__sendEmail--content">
                <img class="preInscription__forgeLogo" src="@\assets\logo-fundacion-forge.png" alt="" />
                <div class="preInscription__title">
                    <h2 style="font-weight: 800;">Inscripción cerrada por cupo completo.</h2>
                </div>
                <span class="preInscription__activity">
                    Te esperamos para inscribirte a partir del <br />
                    <strong>{{ formatDate(startDate) }}</strong>
                </span>
            </div>
        </div>

        <!-- SE USA -->
        <div v-else-if="pageStage === 'Finished'" class="preInscription__sendEmail">
            <div class="preInscription__sendEmail--content">
                <img class="preInscription__forgeLogo" src="@\assets\logo-fundacion-forge.png" alt="" />
                <div class="preInscription__title">
                    <h2 style="font-weight: 800;">Inscripción finalizada.</h2>
                </div>
                <span class="preInscription__activity">
                    La inscripción a este curso finalizó.
                </span>
            </div>
        </div>

        <!-- SE USA -->
        <div v-else-if="pageStage === 'Full'" class="preInscription__sendEmail">
            <div class="preInscription__sendEmail--content">
                <img class="preInscription__forgeLogo" src="@\assets\logo-fundacion-forge.png" alt="" />
                <div class="preInscription__title">
                    <h2 style="font-weight: 800;">Inscripción cerrada por cupo completo.</h2>
                </div>
                <span class="preInscription__activity">
                    Este curso alcanzó su cupo máximo de participantes y ya no está disponible.
                </span>
            </div>
        </div>

    </div>



</template>

<script>
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { ref, onMounted, inject } from 'vue'
import { required, email, helpers } from '@vuelidate/validators'
import useVuelidate from '@vuelidate/core'
import Loader from '../../components/Loader.vue'
import { useI18n } from 'vue-i18n'
import '@vuepic/vue-datepicker/dist/main.css';
import Input from '../../components/Input.vue';
import Select from '../../components/Inputs/Select.vue';
import DatePicker from '../../components/Inputs/DatePicker.vue';
import persistentData from '@/plugins/persistentData';


export default{
    props : {
        coursePreinscriptionId: {
            type: Number,
            default: null
        }
    },
    components: {
        Loader,
        Input,
        Select,
        DatePicker,
    },
    setup(props, { emit }) {
        const route = useRoute()
        const store = useStore()
        const formData = ref([])
        const states = ref({})
        const rules = ref({})
        const captcha = ref(false)
        const formatDate = inject('formatDate')
        const formDataLoaded = ref(false)
        const creationOptions = ref()
        const preInscriptionId = props.coursePreinscriptionId ? props.coursePreinscriptionId : route.params.preInscriptionId
        // const stageId = ref(Number(route.params.stageId) || 0)
        const submitted = ref(false)
        let v$ = useVuelidate()
        const validates = ref({})
        const { t } = useI18n()
        const UTCDate = inject('UTCDate')
        // const thereIsStep2 = ref(false)
        // const thereIs2StepInStep2 = ref(false)
        const backUserData = ref(undefined)
        const firstData = ['EMAIL']
        const basicData = ['FIRSTNAME', 'LASTNAME']
        const allData = ref([])
        // const aditionalData = ref()
        const emailInfoHover = ref(false)
        // PAGINADO
        const pageStage = ref(0) // Ir validando en que etapa de la propia vista se encuentra.
        /*
            1 : Datos básicos
            2 : Datos adicionales
            3 : Datos adicionales Parte 2
            'Stage1Finished' : Stage 1 completado
            'InscriptionFinished' : Stage 2 completado
            'NotStarted' : Preinscripción o inscripción no inicio
            'sendEmail' : En caso de estar en stage > 1 y no tener un GUID, consulta Email
            'emailNotFound' : En caso de que el email o GUID no exista, enviar a pantalla intermedio explicando los pasos a seguir
            'Finished': Preinscripcion finalizada.
            'Full': Preinscripcion llena.
        */
        const onSubmitLoaded = ref(false)
        // const checkEmailLoaded = ref(false)
        const phoneCodes = ref([])
        const startDate = ref(undefined)
        const linkRandParam = Math.round(Math.random()*1000);

        const phoneMaxCharacters = ref(false);
        const checkPhoneCharacters = () => {
            const prefixLength = states.value['PHONECODE'] ? states.value['PHONECODE'].length : 0;
            const totalLength = prefixLength + states.value['PHONE'].length;

            if(totalLength > 40){
                phoneMaxCharacters.value = true;
                states.value['PHONE'] = states.value['PHONE'].slice(0, 40 - prefixLength);
            }
            else{
                phoneMaxCharacters.value = false;
            }
        }


        const dniMaxCharacters = ref(false);
        const checkDniCharacters = () => {
            if(states.value['DNI'].length > 40){
                dniMaxCharacters.value = true;
                states.value['DNI'] = states.value['DNI'].slice(0, 40)
            }
            else{
                dniMaxCharacters.value = false
            }
        }

        // // handlewhyshowinStep must show email in first step, nombre y apellido in second step, and the rest in rest of steps by groups of 3
        // const handleWhyShowInStep = (paramName) => {
        //     if (pageStage.value === 0) {
        //         return allData.value.filter(data => firstData.includes(data.paramName)).some(data => data.paramName === paramName);
        //     }
        //     if (pageStage.value === 1) {
        //         return allData.value.filter(data => basicData.includes(data.paramName)).some(data => data.paramName === paramName);
        //     }
        //     if (pageStage.value === 2) {
        //         return allData.value.filter(data => !firstData.includes(data.paramName) && !basicData.includes(data.paramName)).slice(0, 3).some(data => data.paramName === paramName);
        //     }
        //     if (pageStage.value === 3) {
        //         return allData.value.filter(data => !firstData.includes(data.paramName) && !basicData.includes(data.paramName)).slice(3, 6).some(data => data.paramName === paramName);
        //     }
        //     if (pageStage.value === 4) {
        //         return allData.value.filter(data => !firstData.includes(data.paramName) && !basicData.includes(data.paramName)).slice(6, 9).some(data => data.paramName === paramName);
        //     }
        //     if (pageStage.value === 5) {
        //         return allData.value.filter(data => !firstData.includes(data.paramName) && !basicData.includes(data.paramName)).slice(9, 12).some(data => data.paramName === paramName);
        //     }
        // };

        const loadRecaptcha = () => {
            const recaptchaScript = document.createElement('script');
            recaptchaScript.src = 'https://www.google.com/recaptcha/api.js';
            recaptchaScript.async = true;
            recaptchaScript.defer = true;
            document.head.appendChild(recaptchaScript);
        };



        const handleWhyShowInStep = (paramName) => {
            const remainingData = allData.value.filter(data => !firstData.includes(data.paramName) && !basicData.includes(data.paramName));

            if (pageStage.value === 0) {
                return allData.value.filter(data => firstData.includes(data.paramName)).some(data => data.paramName === paramName);
            }
            if (pageStage.value === 1) {
                return allData.value.filter(data => basicData.includes(data.paramName)).some(data => data.paramName === paramName);
            }

            // Para los siguientes steps, se agrupan los datos en bloques de 3
            const groupSize = 3;
            const startIndex = (pageStage.value - 2) * groupSize;
            const endIndex = startIndex + groupSize;

            // Slice dinámico para evitar problemas si no hay suficientes elementos
            return remainingData.slice(startIndex, endIndex).some(data => data.paramName === paramName);
        };




        const getFormData = async () => {
            formDataLoaded.value = false;
            try {
                let params = {
                    preInscriptionId: preInscriptionId,
                };

                const { data } = await store.dispatch('preInscription_getPreInscriptionSettings', params);
                if (data.status?.toLowerCase() === 'finished') {
                    pageStage.value = 'Finished';
                    formDataLoaded.value = true;
                    return;
                } else if (data.status?.toLowerCase() === 'full') {
                    pageStage.value = 'Full';
                    formDataLoaded.value = true;
                    return;
                }
                if (new Date(data.startDate) > UTCDate.value) {
                    startDate.value = data.startDate;
                    pageStage.value = 'NotStarted';
                    formDataLoaded.value = true;
                    return;
                }
                creationOptions.value = await store.dispatch('preInscription_getCreationOptions');

                formData.value = data;
                // states.value['EMAIL'] && formData.value.category.fields.unshift({
                //     paramName: 'EMAIL',
                //     // isCustomField: false,
                //     values: states.value['EMAIL'],
                //     type: 'SHORTSTRING'
                // });
                if (states.value['EMAIL'] && !formData.value.category.fields.some(field => field.paramName === 'EMAIL')) {
                    formData.value.category.fields.unshift({
                        paramName: 'EMAIL',
                        values: states.value['EMAIL'],
                        type: 'SHORTSTRING'
                    });
                }


                // if formData.value.category is null, return
                if (!formData.value.category) {
                    formDataLoaded.value = true;
                    return;
                }

                formData.value.category.fields.forEach(data => {
                    data.paramType =
                        data.paramType.toUpperCase() === 'SHORTSTRING' ? 'text'
                        : data.paramType.toUpperCase() === 'POSITIVENUMBER' ? 'number'
                        : data.paramType.toUpperCase() === 'BOOLEAN' ? 'checkbox'
                        : data.paramType.toUpperCase() === 'LONGSTRING' ? 'textarea'
                        : data.paramType.toUpperCase();

                    if (data.paramName === 'EMAIL') {
                        states.value['EMAIL'] = states.value['EMAIL'] || null;
                    } else {
                        data.paramType !== 'checkbox' ? states.value[data.paramName] = null : states.value[data.paramName] = false;
                    }

                    if (data.paramName === 'COUNTRY') {
                        data.values = creationOptions.value.data.countries;
                    }

                    if (data.paramName === 'GENDER') {
                        data.values = creationOptions.value.data.genders;
                    }

                    if (data.paramName === 'EMAIL' && !data.values) {
                        states.value['EMAIL'] = '';
                    }

                    if (data.paramName === 'PHONE') {
                        states.value[`${data.paramName}CODE`] = null;
                        phoneCodes.value = creationOptions.value.data.countries.map(country => country.phoneCode);
                    }
                });

                allData.value = formData.value.category.fields;

                for (let models in states.value) {
                    if (models === 'EMAIL') {
                        rules.value[models] = {
                            required: helpers.withMessage('Este campo es requerido.', required),
                            email: helpers.withMessage('El formato del mail es inválido.', email)
                        };
                    } else {
                        rules.value[models] = { required: helpers.withMessage('Este campo es requerido.', required) };
                    }
                }

                v$ = useVuelidate(rules, states);

                for (const state in states.value) {
                    validates.value[state] = v$.value[state];
                }

                formDataLoaded.value = true;
            } catch (err) {
                console.log(err);
            }
        };

        const formCanBeSubmitted = ref(false);
        const fieldsCount = ref(0);
        const pagesCount = ref(0);
        const totalExtraFields = ref(0);


        const onSubmit = async () => {
                var customLinkId = parseInt(persistentData.get('customLinkId'));
                //modify to number
                if (customLinkId) {
                    customLinkId = parseInt(customLinkId);
                }
 
                if (pageStage.value === 0) {
                    //check store with email
                    onSubmitLoaded.value = true
                    try {
                        const params = {
                            preInscriptionId: preInscriptionId,
                            userEmail: states.value['EMAIL']
                        };
                        req = await store.dispatch('preInscription_checkEmailExists', params);

                        //if req.data.fieldsToComplete = 0, do preInscription_postPreInscriptionStage with email 
                        if (req.data.fieldsToComplete.length === 0) {
                            //do same as preInscription_postPreInscriptionStage below, but only send email
                            // alert('no hay fieldsToComplete')

                            req = {
                                preInscriptionId: preInscriptionId,
                                data: [{
                                    paramName: 'EMAIL',
                                    value: states.value['EMAIL'],
                                    type: 'SHORTSTRING'
                                }],
                                LinkId: customLinkId ? customLinkId : null
                            }

                            const response = await store.dispatch('preInscription_postPreInscriptionStage', req);

                            
                            if (response.data.key) {
                                emit('submissionResult', response.data);
                                
                            } else {
                                emit('submissionResult', response.data);
                            }

                            pageStage.value = 'InscriptionFinished'


                            customLinkId ? persistentData.remove('customLinkId') : '';


                        } else {
                            formDataLoaded.value = false;



                            // save email in states
                            let emailValue = states.value['EMAIL'] || null;



                            formData.value.category.fields = req.data.fieldsToComplete;
                            
                            fieldsCount.value = req.data.fieldsToComplete.length;
                            pagesCount.value = Math.ceil(fieldsCount.value / 3);

                            

                            if (formData.value.category.fields.filter(field => field.paramName === 'FIRSTNAME' || field.paramName === 'LASTNAME').length !== 0) {
                                // alert('hay nombre apellido')
                                // nombre y apellido has own pageStage with 2 fields which are not in other pages -1
                                // pagesCount.value = pagesCount.value - 1;
                                // alert(pagesCount.value)
                            } else {
                                // alert('no hay nombre apellido')
                                // +1
                                pagesCount.value = pagesCount.value + 1;
                                // alert(pagesCount.value)
                            }

                            if (states.value['EMAIL'] && !formData.value.category.fields.some(field => field.paramName === 'EMAIL')) {
                                formData.value.category.fields.unshift({
                                    paramName: 'EMAIL',
                                    values: states.value['EMAIL'],
                                    type: 'SHORTSTRING'
                                });
                            }


                            // if formData.value.category is null, return
                            if (!formData.value.category) {
                                formDataLoaded.value = true;
                                return;
                            }

                            // alert('aca llega')
                            

                            formData.value.category.fields.forEach(data => {
                                if (!data.paramType) return;

                                data.paramType =
                                    data.paramType.toUpperCase() === 'SHORTSTRING' ? 'text'
                                    : data.paramType.toUpperCase() === 'POSITIVENUMBER' ? 'number'
                                    : data.paramType.toUpperCase() === 'BOOLEAN' ? 'checkbox'
                                    : data.paramType.toUpperCase() === 'LONGSTRING' ? 'textarea'
                                    : data.paramType.toUpperCase();

                                if (data.paramName === 'EMAIL') {
                                    states.value['EMAIL'] = states.value['EMAIL'] || null;
                                } else {
                                    data.paramType !== 'checkbox' ? states.value[data.paramName] = null : states.value[data.paramName] = false;
                                }

                                if (data.paramName === 'COUNTRY' && creationOptions.value.data.countries) {
                                    data.values = creationOptions.value.data.countries;
                                }

                                if (data.paramName === 'GENDER' && creationOptions.value.data.genders) {
                                    data.values = creationOptions.value.data.genders;
                                }

                                if (data.paramName === 'EMAIL' && !data.values) {
                                    states.value['EMAIL'] = '';
                                }

                                if (data.paramName === 'PHONE' && creationOptions.value.data.countries) {
                                    states.value[`${data.paramName}CODE`] = null;
                                    phoneCodes.value = creationOptions.value.data.countries.map(country => country.phoneCode);
                                }
                            });


                            // alert('aca llega 2')


                            

                            allData.value = formData.value.category.fields;


                            for (let models in states.value) {
                                if (models === 'EMAIL') {
                                    rules.value[models] = {
                                        required: helpers.withMessage('Este campo es requerido.', required),
                                        email: helpers.withMessage('El formato del mail es inválido.', email)
                                    };
                                } else {
                                    rules.value[models] = { required: helpers.withMessage('Este campo es requerido.', required) };
                                }
                            }

                            v$ = useVuelidate(rules, states);

                            for (const state in states.value) {
                                validates.value[state] = v$.value[state];
                            }


                            // set emailValue in EMAIL
                            states.value['EMAIL'] = emailValue;






                            formDataLoaded.value = true;


                            // pageStage.value = 1;
                            // if there are no nombre y apellido, go to pageStage 2, else go to pageStage 1
                            if (formData.value.category.fields.filter(field => field.paramName === 'FIRSTNAME' || field.paramName === 'LASTNAME').length === 0) {
                                pageStage.value = 2;
                            } else {
                                pageStage.value = 1;
                            }



                            formCanBeSubmitted.value = true;
                            
                            
                            
                            
                        }

                        onSubmitLoaded.value = false
                        return
                    } catch (err) {
                        store.dispatch("notifications_create", {text: t(`preInscription.error.${err.response.data}`)});
                        onSubmitLoaded.value = false
                        return
                    }
                }
                // pageStage.value < pagesCount.value and there are pending fields
                if (pageStage.value < pagesCount.value) {
                    pageStage.value++;
                    console.log("Avanzando a la página:", pageStage.value);
                    return;
                } else {
                    console.log("Última página alcanzada. No hay más campos para mostrar.");
                }


                // if (v$.value.$invalid || onSubmitLoaded.value) {
                // do if invalid for current existing fields (becouse they can change after email check), also || onSubmitLoaded.value and ignore email
                if ( formData.value.category.fields.some(field => field.paramName in states.value && v$.value[field.paramName].$invalid) || onSubmitLoaded.value) {
                    // if (v$.value.$invalid) {
                    // alert(v$.value.$invalid)
                    // alert fields
                    // alert(JSON.stringify(v$.value))
                    submitted.value = true
                    // stageId.value == 2  ?  pageStage.value = 2 : pageStage.value = 1 //volver a la etapa 1 si hay un error
                    // alert('aca llega 3')
                    // alert to show error and debug all info
                    // pageStage.value = 1
                    // if nombre exists, go to pageStage 1, else go to pageStage 2
                    // if fields with paramtype are name OR lastname, go to pageStage 1, else go to pageStage 2
                    // if (formData.value.category.fields.filter(field => field.paramName === 'FIRSTNAME' || field.paramName === 'LASTNAME').length !== 0) {
                        // pageStage.value = 1;



                    // instead of FIRSTNAME and LASTNAME (basicData) use basicData
                    // if (formData.value.category.fields.filter(field => field.paramName === 'FIRSTNAME' || field.paramName === 'LASTNAME').length === 0) {
                    if (formData.value.category.fields.filter(field => basicData.includes(field.paramName)).length === 0) {
                        pageStage.value = 2;
                    } else {
                        pageStage.value = 1;
                    }
                    return
                }
                // alert('aca llega 4')
                // Set object para back
                let req = {
                    preInscriptionId: preInscriptionId,
                    data: formData.value.category.fields.map(data => {
                        return {
                            paramName: data.paramName,
                            value: data.paramName === 'PHONE' ? `${states.value[data.paramName+'CODE']}${states.value[data.paramName]}` : states.value[data.paramName], // Si es un telefono, se concatena el prefijo y el numero (Por el momento es con el name, a futuro va a ser por type)
                            type: data.paramType === 'text' ? 'SHORTSTRING'
                                : data.paramType === 'number' ? 'POSITIVENUMBER'
                                : data.paramType === 'checkbox' ? 'BOOLEAN'
                                : data.paramType === 'textarea' ? 'LONGSTRING'
                                : data.paramType
                        }
                    }),
                    LinkId: customLinkId ? customLinkId : null
                }

                try{
                    onSubmitLoaded.value = true
                    // await store.dispatch('preInscription_postPreInscriptionStage', req)
                    
                    
                    
                    
                    const response = await store.dispatch('preInscription_postPreInscriptionStage', req);
                    // hardcode test
                    // const response = {data: {key: 'testfinished'}}
                    // alert(response.data.key)
                    
                    if (response.data.key) {
                        emit('submissionResult', response.data);
                    } else {
                        emit('submissionResult', response.data);
                    }

                    customLinkId ? persistentData.remove('customLinkId') : '';


                    submitted.value = false
                    pageStage.value = 'InscriptionFinished'
                    onSubmitLoaded.value = false
                    return req
                }

                // emit 
                
                catch(err){
                    store.dispatch("notifications_create", {text: t(`preInscription.error.${err.response.data}`)});
                    onSubmitLoaded.value = false
                }
                // emit('update:modelValue', 'testfinished')
            }

            const onSubmitCaptcha = async () => {
                onSubmitLoaded.value = true
                //('#g-recaptcha-response')[0].value;
                const captchaResponse = document.getElementById('g-recaptcha-response').value;
                // alert(captchaResponse)
                // console.log(captchaResponse)

                // linkId
                var customLinkId = parseInt(persistentData.get('customLinkId'));
                //modify to number
                if (customLinkId) {
                    customLinkId = parseInt(customLinkId);
                }

                try {
                    let req = {
                        preInscriptionId: preInscriptionId,
                        LinkId: customLinkId ? customLinkId : null,
                        captchaResponse: captchaResponse

                    }

                    const response = await store.dispatch('preInscription_postPreInscriptionStage', req);

                    if (response.data.key) {
                        emit('submissionResult', response.data);
                    } else {
                        emit('submissionResult', null);
                    }

                    pageStage.value = 1
                    onSubmitLoaded.value = false

                    customLinkId ? persistentData.remove('customLinkId') : '';


                    // reset captcha
                    window.grecaptcha.reset();

                    return

                } catch (err) {
                    store.dispatch("notifications_create", {text: t(`preInscription.error.${err.response.data}`)});
                    onSubmitLoaded.value = false

                    // reset captcha
                    window.grecaptcha.reset();
                    
                    return
                }
            }

            const format = (date) => {
                const day = date.getDate()
                const month = date.getMonth() + 1
                const year = date.getFullYear()

                return `${day}/${month}/${year}`
            }
            

            const userData = persistentData.get('user', true)
            const emailDisabled = ref(false);

            onMounted(async () => {
                await getFormData();
                // if formData.courseType "REGULAR"  && get manageUser_logged is true, dispatch manageUser_disabled
                // await store.dispatch("manageUser_disabled");
                var isUserLogged = store.getters.manageUser_logged;
                if (formData.value.courseType === 'REGULAR' && isUserLogged) {
                    await store.dispatch("manageUser_disabled");
                }



                loadRecaptcha();  // Llama el método para cargar reCAPTCHA

                const email = userData.email;
                if (email && formData.value.courseType === 'ON_DEMAND') {
                    states.value['EMAIL'] = email;
                    emailDisabled.value = true;
                }

            });

            return {
                formData,
                emailDisabled,
                userData,
                onSubmit,
                onSubmitCaptcha,
                states,
                captcha,
                rules,
                formDataLoaded,
                v$,
                creationOptions,
                submitted,
                validates,
                pageStage,
                onSubmitLoaded,
                route,
                backUserData,
                preInscriptionId,
                getFormData,
                format,
                phoneCodes,
                handleWhyShowInStep,
                firstData,
                basicData,
                emailInfoHover,
                startDate,
                formatDate,
                linkRandParam,
                phoneMaxCharacters,
                checkPhoneCharacters,
                dniMaxCharacters,
                checkDniCharacters,
                pagesCount,
                fieldsCount,
                totalExtraFields,
            }
        }
    }

</script>

<style src="@vueform/multiselect/themes/default.css"></style>
<style lang="scss">
@import "@/styles/main.scss";

$formGap: 12px;
.preInscription{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    &__container{
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 50%;
        background-color: #fff;
        height: 100vh;
        overflow-y: auto;
        position: relative;
        @media screen and (max-width: $bpBig) {
            width: 100%;
        }
    }
    &__forgeLogo{
        width: 89px;
        margin: 0 auto;
    }
    &__image{
        background-image: url(../../assets/preinscription_portrait.png);
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        width: 50%;
        height: 100vh;
        @media screen and (max-width: $bpMedium){
            display: none;
        }
        &--joven {
            background-image: url(../../assets/preinscription_joven.png);
        }
    }
    &__title{
        text-align: center;
        display: flex;
        flex-direction: column;
        gap: 4px;
        h2{
            font-weight: 600;
        }
        strong{
            font-size: 24px;
        }
    }
    &__emailhover{
        position: absolute;
        right: 12px;
        font-size: 20px;
    }
    &__sendEmail{
        width: 50%;
        display: flex;
        justify-content: center;
        background: #fff;
        height: 100vh;
        &--content{
            display: flex;
            flex-direction: column;
            gap: 24px;
            align-items: center;
            justify-content: center;
            width: 64%;
            margin: 12px 0;
        }
    }
    &__emailInfo{
        position: absolute;
        max-width: 200px;
        top: 36px;
        background-color: map-get($primary, onMediumEmphasis );
        right: -75px;
        display: flex;
        flex-direction: column;
        gap: 6px;
        padding: 12px;
        font-size: 11px;
        font-weight: 400;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 10px;
    }
    &__stages{
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        width: 100%;
        border-bottom: 1px solid $lightgray;
        padding: 28px 0;
        gap: 12px;
        font-size: 13px;
        &--pending{
            display: flex;
            align-items: center;
            gap: 8px;
            font-weight: 600;
            .preInscription__stages--stageNumber{
                width: 28px;
                height: 28px;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: $orange;
                border-radius: 9999px;
            }
        }
        &--disabled{
            opacity: .3;
            display: flex;
            align-items: center;
            gap: 8px;
            .preInscription__stages--stageNumber{
                display: flex;
                align-items: center;
                justify-content: center;
                width: 28px;
                height: 28px;
                background-color: $lightgray !important;
                border-radius: 9999px;
            }
        }
        &--done{
            display: flex;
            align-items: center;
            gap: 8px;
            font-weight: 600;
            .preInscription__stages--stageNumber{
                display: flex;
                align-items: center;
                justify-content: center;
                width: 28px;
                height: 28px;
                background-color: #77C991 !important;
                color: #fff;
                border-radius: 9999px;
            }
        }
    }
    &--activity{
        text-align: center;
        font-weight: 600;
    }
    &__content{
        display: flex;
        flex-direction: column;
        gap: 24px;
        align-items: center;
        width: 64%;
        margin: 12px 0;
        @media screen and (max-width: $bpSmall) {
            width: 80%;
        }
    }
    &__form{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 100%;
        gap: $formGap;
        &--doubleSelect{
            display: flex;
            width: 100%;
            gap: 6px;
            >div{
                width: 60%;
            }
        }
        &--input{
            height: 42px;
            width: 100%;
            padding: 12px 22px;
            background: #f6f6f6;
            border: none;
            border-radius: 26px;
            color: #212121;
            display: flex;
            align-items: center;
            &__checkbox{
                @extend .preInscription__form--input;
                background-color: inherit;
                padding: 0 12px;
                gap: 6px;
            }
        }
        &--label{
            font-size: 12px;
            color: $black;
            opacity: .8;
            background-color: #f6f6f6;
            width: fit-content;
        }
        label{
            display: flex;
            justify-content: space-between;
            align-items: center;
            color: $black;
            position: relative;
            width: 100%;
        }
        .dropdown{
            &__face{
                padding: 9px 22px;
                background-color: $whitegray;
                border: none;
            }
            &__items, &__items--deleted{
                top: calc(100% + 5px) !important;
                border-radius: 25px;
            }
            &__items{
                border: none;
                box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
            }
            input {
                display: none;
                &:checked ~ .dropdown__items {
                top: calc(100% + 10px);
                visibility: visible;
                opacity: 1;
                z-index: 9999;
                gap: 18px;
                }
            }
        }
    }
    &__buttons{
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 14px;
        width: 100%;
    }
    &__button{
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;
        padding: 10px 26px;
        border-radius: 9999px;
        width: 100%;
        &--forward{
            @extend .preInscription__button;
            background-color: $green;
            color: #fff;
        }
        .material-icons-outlined{
            font-size: 15px;
            width: 15px;
        }
        &--backward{
            @extend .preInscription__button;
            background-color: inherit;
            color: $green;
            border: 1px solid $green;
        }
    }


    &__continue{
        width: 50%;
        background-color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        height: 100vh;
        gap: 32px;
        padding: 0 7%;
        h3{
            text-align: center;
            font-weight: 600;
            font-size: 24px;
        }
        &--howContinue{
            text-align: center;
            font-size: 16px;
        }
    }
    &__activity{
        text-align: center;
    }
}
button:disabled{
    opacity: .4;
    cursor: default;
}

input:read-only{
    color: rgba($color: #000000, $alpha: .4);
}

.input-message {
  padding-left: 12px;
  @include icon-and-text-container;
  gap: 4px;
  display: inline-flex; 
  font-size: 13px;
  color: $login-error-color;
  .material-icons{
    font-size: 18px;
  }
}

.terms{
    width: 100%;
    text-align: center;
    font-size: 11px;
    font-weight: 500;
    a{
    color: $green;
    }
}
</style>